
import {TypeInt, TypeFloat, TypeChar, TypeBool, TypeError} from './../TypeDefinition'

function ParseType (parser) {
    this.parser = parser
    this.SC = this.parser.config
}

ParseType.prototype = {
    parse () {
        let declarationType = false

        if (this.parser.scanner.nextIs(this.SC.K_INT)) {
            declarationType = TypeInt()
        } else if (this.parser.scanner.nextIs(this.SC.K_FLOAT)) {
            declarationType = TypeFloat()
        } else if (this.parser.scanner.nextIs(this.SC.K_CHAR)) {
            declarationType = TypeChar()
        } else if (this.parser.scanner.nextIs(this.SC.K_BOOL)) {
            declarationType = TypeBool()
        } else {
            if (this.parser.hintHelper) {
                this.parser.hintHelper.checkTokensForHints([this.SC.K_INT, this.SC.K_FLOAT, this.SC.K_CHAR, this.SC.K_BOOL])
            }
            this.parser.error(this.parser.scanner.next(), 'El tipo no se reconoce, se esperaba Entero, Caracter, Logico o Real')
            return TypeError()
        }

        this.parser.scanner.consume()

        return declarationType
    }
}

export default ParseType



// WEBPACK FOOTER //
// ./src/Core/Parser/Components/ParseType.js